let config;

// 获取当前域名
const hostname = window.location.hostname;

if (hostname === 'test.maintenance.akuvox.com') {
    config = require('../config/config.test.js').default;
}else if (hostname === 'maintenance.akuvox.com') {
    config = require('../config/config.prod.js').default;
}else{
    config = require('../config/config.dev.js').default;
}


export const ENV=config.ENV;

//设备远程日志---websocket 地址
export const BASE_LOG_URI=config.BASE_LOG_URI;

//域名地址
export const MAINTENANCE_DOMAIN=config.MAINTENANCE_DOMAIN;